import { status } from '../../../../constants/attendanceStatus'
import { isUnconfirmedRosterSpare } from './rosterSpareConfirm'

export interface AttendanceCounts {
  yes: number
  maybe: number
  no: number
  unknown: number
  total: number
}

/**
 * `promotedRequestById` (player id → availability request id) marks promoted
 * spare candidates, which count as confirmed roster spares.
 */
export const getAttendanceCounts = (
  players: any[],
  promotedRequestById?: Readonly<Record<string, string>>
): AttendanceCounts => {
  const counts: AttendanceCounts = {
    yes: 0,
    maybe: 0,
    no: 0,
    unknown: 0,
    total: players.length,
  }
  for (const player of players) {
    switch (player?.attendance_status) {
      case status.ATTENDING:
        // A roster spare's Yes only counts once a team official confirms them
        // for the game (SN-8476); until then it counts as Unknown.
        if (isUnconfirmedRosterSpare(player, promotedRequestById)) {
          counts.unknown++
        } else {
          counts.yes++
        }
        break
      case status.NOT_ATTENDING:
        counts.no++
        break
      case status.MAYBE:
        counts.maybe++
        break
      default:
        counts.unknown++
    }
  }
  return counts
}
